import { AxiosPromise } from 'axios';
import * as servicesCustomerRegisterTypes from 'src/app/services/customerAndUserInvitations/customerAndUserInvitations.service.type';
import { axios } from 'src/app/utils';
import { finalUrlsConfig } from 'src/configs/url.config';

// LookUp
export const lookupCustomerInvitations = (): // params?: servicesCustomerRegisterTypes.LookUpTroubleTicketDataType
AxiosPromise<servicesCustomerRegisterTypes.CustomerInvitationsLookUpResultType> => {
  return axios.get(finalUrlsConfig().customerAndUserInvitations.customerInvitations);
};

export default {
  lookupCustomerInvitations,
};
